import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  
  CardGpx: {},
  listItem: {
    width: "48%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",

    borderBottomWidth: 1,
    borderBottomColor: "#aaa",
    paddingVertical: 8,
  },
  icon: {
    width: 48,
    height: 48,
  },
  itemTextSection: {
    flex: 1,
    marginHorizontal: 16,
  },
  textBold: {
    fontWeight: "bold",
  },
});
